import namespacedStorage from '../../utils/namespaced-storage'

export const getExperimentsStorage = () => {
  return namespacedStorage('toast-oo-experiments')
}
